import {
  MicroFrontends,
  MicroFrontendSubModules,
} from "../../constants/MicroFrontendConfig";
import { MicroFrontendConfig } from "../../types/MicroFrontendConfig.types";
import { getCurrentStage, Stages } from "./StageConfig";

/* This is used to append a unique timestamp to the URL for the micro-frontend resources. This ensures that 
the browser always loads the latest version of the resource by preventing caching issues. The timestamp is 
generated using the current date and time, making each request URL unique. Since `remoteEntry.js` is typically
a small-sized file that only contains the necessary entry point for the micro-frontend, appending a cache buster
won't result in any significant performance overhead or issues. */
const cacheBuster = Date.now();

const MicroFrontendEndpoints: { [key in MicroFrontends]: string } = {
  [Stages.LOCAL]: {
    [MicroFrontends.VIDEO_COMMERCE]:
      `http://localhost.amazon.com:3030/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.STORE_ONBOARDING]:
      `https://localhost.amazon.com:3030/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.STORE_POLICIES]:
      `https://localhost.amazon.com:3030/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.BUSINESS_DETAILS]:
      `https://localhost.amazon.com:3030/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.CATALOG]:
      `https://localhost.amazon.com:3031/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.OMS_MODULE]:
      `https://localhost.amazon.com:3032/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.ANALYTICS]:
      `https://localhost.amazon.com:3033/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.WEBSITE_APPEARANCE]:
      `https://localhost.amazon.com:3031/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.PERFORMANCE_MARKETING]:
      `https://localhost.amazon.com:3036/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.PAYMENTS]:
      `https://localhost.amazon.com:3039/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.STORE_TIMINGS]:
      `https://localhost.amazon.com:3035/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.PROFILE]:
      `https://localhost.amazon.com:3041/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.DELIVERY_SETTINGS]:
      `https://localhost.amazon.com:3040/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.HOME]: `https://localhost.amazon.com:3085/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.OFFERS]: `https://localhost.amazon.com:3042/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.CUSTOM_DOMAIN]:
      `https://localhost.amazon.com:3043/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.GOOGLE_ANALYTICS]:
      `https://localhost.amazon.com:3036/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.USER_MANAGEMENT]:
      `https://localhost.amazon.com:3031/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.SEO]: `https://localhost.amazon.com:3036/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.RETURN_SETTINGS]:
    `https://localhost.amazon.com:3032/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.SETTINGS]:
      `https://localhost.amazon.com:3041/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.MARKETING_AUTOMATION]:
      `https://localhost.amazon.com:3036/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.REVIEWS]:
      `https://localhost.amazon.com:3044/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.REVIEW_SETTINGS]:
      `https://localhost.amazon.com:3044/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.CONNECTIONS]:
      `https://localhost.amazon.com:3045/remoteEntry.js?t=${cacheBuster}`,
  },
  [Stages.ALPHA]: {
    [MicroFrontends.VIDEO_COMMERCE]:
      `https://d2w5vf7w9iyge.cloudfront.net/videocommerce/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.STORE_ONBOARDING]:
      `https://d39a3leohiyygs.cloudfront.net/storeonboarding/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.STORE_POLICIES]:
      `https://d39a3leohiyygs.cloudfront.net/storeonboarding/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.BUSINESS_DETAILS]:
      `https://d39a3leohiyygs.cloudfront.net/storeonboarding/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.CATALOG]:
      `https://d39a3leohiyygs.cloudfront.net/catalog/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.OMS_MODULE]:
      `https://d39a3leohiyygs.cloudfront.net/oms/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.ANALYTICS]:
      `https://d39a3leohiyygs.cloudfront.net/analytics/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.WEBSITE_APPEARANCE]:
      `https://d2w5vf7w9iyge.cloudfront.net/storeappearance/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.PERFORMANCE_MARKETING]:
      `https://d39a3leohiyygs.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.PAYMENTS]:
      `https://d39a3leohiyygs.cloudfront.net/payments/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.STORE_TIMINGS]:
      `https://d39a3leohiyygs.cloudfront.net/storetimings/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.PROFILE]:
      `https://d39a3leohiyygs.cloudfront.net/profile/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.DELIVERY_SETTINGS]:
      `https://d39a3leohiyygs.cloudfront.net/deliverysettings/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.HOME]:
      `https://d39a3leohiyygs.cloudfront.net/home/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.OFFERS]:
      `https://d39a3leohiyygs.cloudfront.net/offers/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.CUSTOM_DOMAIN]:
      `https://d39a3leohiyygs.cloudfront.net/customdomain/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.GOOGLE_ANALYTICS]:
      `https://d39a3leohiyygs.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.USER_MANAGEMENT]:
      `https://d39a3leohiyygs.cloudfront.net/usermanagement/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.SEO]:
      `https://d39a3leohiyygs.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.RETURN_SETTINGS]:
      `https://d39a3leohiyygs.cloudfront.net/oms/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.SETTINGS]:
      `https://d39a3leohiyygs.cloudfront.net/profile/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.MARKETING_AUTOMATION]:
      `https://d39a3leohiyygs.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.REVIEWS]:
      `https://d2w5vf7w9iyge.cloudfront.net/reviews/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.REVIEW_SETTINGS]:
      `https://d2w5vf7w9iyge.cloudfront.net/reviews/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.CONNECTIONS]:
      `https://d2w5vf7w9iyge.cloudfront.net/marketplaceconnector/remoteEntry.js?t=${cacheBuster}`,
  },
  [Stages.BETA]: {
    [MicroFrontends.VIDEO_COMMERCE]:
      `https://d17bnpeb45miu4.cloudfront.net/videocommerce/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.STORE_ONBOARDING]:
      `https://d9sewsark1uqw.cloudfront.net/storeonboarding/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.STORE_POLICIES]:
      `https://d9sewsark1uqw.cloudfront.net/storeonboarding/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.BUSINESS_DETAILS]:
      `https://d9sewsark1uqw.cloudfront.net/storeonboarding/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.CATALOG]:
      `https://d9sewsark1uqw.cloudfront.net/catalog/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.OMS_MODULE]:
      `https://d9sewsark1uqw.cloudfront.net/oms/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.ANALYTICS]:
      `https://d9sewsark1uqw.cloudfront.net/analytics/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.WEBSITE_APPEARANCE]:
      `https://d17bnpeb45miu4.cloudfront.net/storeappearance/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.PERFORMANCE_MARKETING]:
      `https://d9sewsark1uqw.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.PAYMENTS]:
      `https://d9sewsark1uqw.cloudfront.net/payments/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.STORE_TIMINGS]:
      `https://d9sewsark1uqw.cloudfront.net/storetimings/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.PROFILE]:
      `https://d9sewsark1uqw.cloudfront.net/profile/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.DELIVERY_SETTINGS]:
      `https://d9sewsark1uqw.cloudfront.net/deliverysettings/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.HOME]:
      `https://d9sewsark1uqw.cloudfront.net/home/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.OFFERS]:
      `https://d9sewsark1uqw.cloudfront.net/offers/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.CUSTOM_DOMAIN]:
      `https://d9sewsark1uqw.cloudfront.net/customdomain/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.GOOGLE_ANALYTICS]:
      `https://d9sewsark1uqw.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.USER_MANAGEMENT]:
      `https://d9sewsark1uqw.cloudfront.net/usermanagement/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.SEO]:
      `https://d9sewsark1uqw.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.RETURN_SETTINGS]:
      `https://d9sewsark1uqw.cloudfront.net/oms/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.SETTINGS]:
      `https://d9sewsark1uqw.cloudfront.net/profile/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.MARKETING_AUTOMATION]:
      `https://d9sewsark1uqw.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.REVIEWS]:
      `https://d17bnpeb45miu4.cloudfront.net/reviews/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.REVIEW_SETTINGS]:
      `https://d17bnpeb45miu4.cloudfront.net/reviews/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.CONNECTIONS]:
      `https://d17bnpeb45miu4.cloudfront.net/marketplaceconnector/remoteEntry.js?t=${cacheBuster}`,
  },
  [Stages.GAMMA]: {
    [MicroFrontends.VIDEO_COMMERCE]:
      `https://d293of1br3narv.cloudfront.net/videocommerce/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.STORE_ONBOARDING]:
      `https://dhve5w8xd3t45.cloudfront.net/storeonboarding/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.STORE_POLICIES]:
      `https://dhve5w8xd3t45.cloudfront.net/storeonboarding/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.BUSINESS_DETAILS]:
      `https://dhve5w8xd3t45.cloudfront.net/storeonboarding/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.CATALOG]:
      `https://dhve5w8xd3t45.cloudfront.net/catalog/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.OMS_MODULE]:
      `https://dhve5w8xd3t45.cloudfront.net/oms/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.ANALYTICS]:
      `https://dhve5w8xd3t45.cloudfront.net/analytics/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.WEBSITE_APPEARANCE]:
      `https://d293of1br3narv.cloudfront.net/storeappearance/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.PERFORMANCE_MARKETING]:
      `https://dhve5w8xd3t45.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.PAYMENTS]:
      `https://dhve5w8xd3t45.cloudfront.net/payments/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.STORE_TIMINGS]:
      `https://dhve5w8xd3t45.cloudfront.net/storetimings/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.PROFILE]:
      `https://dhve5w8xd3t45.cloudfront.net/profile/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.DELIVERY_SETTINGS]:
      `https://dhve5w8xd3t45.cloudfront.net/deliverysettings/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.HOME]:
      `https://dhve5w8xd3t45.cloudfront.net/home/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.OFFERS]:
      `https://dhve5w8xd3t45.cloudfront.net/offers/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.CUSTOM_DOMAIN]:
      `https://dhve5w8xd3t45.cloudfront.net/customdomain/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.GOOGLE_ANALYTICS]:
      `https://dhve5w8xd3t45.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.USER_MANAGEMENT]:
      `https://dhve5w8xd3t45.cloudfront.net/usermanagement/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.SEO]:
      `https://dhve5w8xd3t45.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.RETURN_SETTINGS]:
      `https://dhve5w8xd3t45.cloudfront.net/oms/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.SETTINGS]:
      `https://dhve5w8xd3t45.cloudfront.net/profile/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.MARKETING_AUTOMATION]:
      `https://dhve5w8xd3t45.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.REVIEWS]:
      `https://d293of1br3narv.cloudfront.net/reviews/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.REVIEW_SETTINGS]:
      `https://d293of1br3narv.cloudfront.net/reviews/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.CONNECTIONS]:
      `https://d293of1br3narv.cloudfront.net/marketplaceconnector/remoteEntry.js?t=${cacheBuster}`,
  },
  [Stages.PROD]: {
    [MicroFrontends.VIDEO_COMMERCE]:
      `https://d2suhi7i28p7w7.cloudfront.net/videocommerce/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.STORE_ONBOARDING]:
      `https://d19m9q66cbq022.cloudfront.net/storeonboarding/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.STORE_POLICIES]:
      `https://d19m9q66cbq022.cloudfront.net/storeonboarding/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.BUSINESS_DETAILS]:
      `https://d19m9q66cbq022.cloudfront.net/storeonboarding/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.CATALOG]:
      `https://d19m9q66cbq022.cloudfront.net/catalog/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.OMS_MODULE]:
      `https://d19m9q66cbq022.cloudfront.net/oms/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.ANALYTICS]:
      `https://d19m9q66cbq022.cloudfront.net/analytics/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.WEBSITE_APPEARANCE]:
      `https://d2suhi7i28p7w7.cloudfront.net/storeappearance/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.PERFORMANCE_MARKETING]:
      `https://d19m9q66cbq022.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.PAYMENTS]:
      `https://d19m9q66cbq022.cloudfront.net/payments/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.STORE_TIMINGS]:
      `https://d19m9q66cbq022.cloudfront.net/storetimings/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.PROFILE]:
      `https://d19m9q66cbq022.cloudfront.net/profile/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.DELIVERY_SETTINGS]:
      `https://d19m9q66cbq022.cloudfront.net/deliverysettings/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.HOME]:
      `https://d19m9q66cbq022.cloudfront.net/home/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.OFFERS]:
      `https://d19m9q66cbq022.cloudfront.net/offers/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.CUSTOM_DOMAIN]:
      `https://d19m9q66cbq022.cloudfront.net/customdomain/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.GOOGLE_ANALYTICS]:
      `https://d19m9q66cbq022.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.USER_MANAGEMENT]:
      `https://d19m9q66cbq022.cloudfront.net/usermanagement/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.SEO]:
      `https://d19m9q66cbq022.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.RETURN_SETTINGS]:
      `https://d19m9q66cbq022.cloudfront.net/oms/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.SETTINGS]:
      `https://d19m9q66cbq022.cloudfront.net/profile/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.MARKETING_AUTOMATION]:
      `https://d19m9q66cbq022.cloudfront.net/performancemarketing/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.REVIEWS]:
      `https://d2suhi7i28p7w7.cloudfront.net/reviews/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.REVIEW_SETTINGS]:
      `https://d2suhi7i28p7w7.cloudfront.net/reviews/remoteEntry.js?t=${cacheBuster}`,
    [MicroFrontends.CONNECTIONS]:
      `https://d2suhi7i28p7w7.cloudfront.net/marketplaceconnector/remoteEntry.js?t=${cacheBuster}`,
  },
}[getCurrentStage()];

export const MICRO_FRONTENDS_CONFIG: MicroFrontendConfig = {
  [MicroFrontends.HOME]: {
    key: MicroFrontends.HOME,
    name: "Home",
    path: "home",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.HOME],
    scope: "RangoliSellerDesktopHomeModule",
    module: "./HomePage",
  },
  [MicroFrontends.CATALOG]: {
    key: MicroFrontends.CATALOG,
    name: "Catalog",
    path: "catalog",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.CATALOG],
    scope: "RangoliSellerDesktopCatalogModule",
    module: "./Catalog",
    subModules: {
      [MicroFrontendSubModules[MicroFrontends.CATALOG].PRODUCTS]: {
        name: "Products",
        path: "products",
      },
      [MicroFrontendSubModules[MicroFrontends.CATALOG].CATEGORIES]: {
        name: "Categories",
        path: "categories",
      },
      [MicroFrontendSubModules[MicroFrontends.CATALOG].COLLECTIONS]: {
        name: "Collections",
        path: "collections",
      },
    },
  },
  [MicroFrontends.OMS_MODULE]: {
    key: MicroFrontends.OMS_MODULE,
    name: "Orders",
    path: "orders",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.OMS_MODULE],
    scope: "RangoliSellerDesktopOMSModule",
    module: "./OMS",
    subModules: {
      [MicroFrontendSubModules[MicroFrontends.OMS_MODULE].ALL_ORDERS]: {
        name: "All Orders",
        path: "",
      },
      [MicroFrontendSubModules[MicroFrontends.OMS_MODULE].RETURNS]: {
        name: "Returns",
        path: "returns",
      },
    },
  },
  [MicroFrontends.ANALYTICS]: {
    key: MicroFrontends.ANALYTICS,
    name: "Analytics",
    path: "analytics",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.ANALYTICS],
    scope: "RangoliSellerDesktopAnalyticsModule",
    module: "./Analytics",
    subModules: {
      [MicroFrontendSubModules[MicroFrontends.ANALYTICS].SALES]: {
        name: "Sales",
        path: "sales",
      },
      [MicroFrontendSubModules[MicroFrontends.ANALYTICS].TRAFFIC]: {
        name: "Traffic",
        path: "traffic",
      },
      [MicroFrontendSubModules[MicroFrontends.ANALYTICS].OPERATIONS]: {
        name: "Operations",
        path: "operations",
      },
      [MicroFrontendSubModules[MicroFrontends.ANALYTICS].ORDERS]: {
        name: "Order",
        path: "order",
      },
      [MicroFrontendSubModules[MicroFrontends.ANALYTICS].OFFERS]: {
        name: "Offer",
        path: "offer",
      },
      [MicroFrontendSubModules[MicroFrontends.ANALYTICS].SALES]: {
        name: "Sales",
        path: "sales",
      },
      [MicroFrontendSubModules[MicroFrontends.ANALYTICS].RETURNS]: {
        name: "Return",
        path: "return",
      },
      [MicroFrontendSubModules[MicroFrontends.ANALYTICS].CUSTOMER_DETAILS]: {
        name: "Customer Details",
        path: "customer-details",
      },
      [MicroFrontendSubModules[MicroFrontends.ANALYTICS].CUSTOMER_SEGMENTS]: {
        name: "Customer Segments",
        path: "customer-segments",
      },
      [MicroFrontendSubModules[MicroFrontends.ANALYTICS].REPORTS]: {
        name: "Reports",
        path: "reports",
      },
    },
  },
  [MicroFrontends.VIDEO_COMMERCE]: {
    key: MicroFrontends.VIDEO_COMMERCE,
    name: "Sell Using Videos",
    path: "sell-using-videos",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.VIDEO_COMMERCE],
    scope: "RangoliSellerDesktopVideoCommerceModule",
    module: "./VideoCommerceApp",
  },
  [MicroFrontends.STORE_ONBOARDING]: {
    key: MicroFrontends.STORE_ONBOARDING,
    name: "Store onboarding",
    path: "store-onboarding",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.STORE_ONBOARDING],
    scope: "RangoliSellerDesktopStoreOnboardingModule",
    module: "./StoreOnboarding",
  },
  [MicroFrontends.STORE_POLICIES]: {
    key: MicroFrontends.STORE_POLICIES,
    name: "Store policies",
    path: "store-policies",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.STORE_POLICIES],
    scope: "RangoliSellerDesktopStoreOnboardingModule",
    module: "./StorePolicies",
  },
  [MicroFrontends.BUSINESS_DETAILS]: {
    key: MicroFrontends.BUSINESS_DETAILS,
    name: "Business details",
    path: "business-details",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.BUSINESS_DETAILS],
    scope: "RangoliSellerDesktopStoreOnboardingModule",
    module: "./AddBusinessDetails",
  },
  [MicroFrontends.PAYMENTS]: {
    key: MicroFrontends.PAYMENTS,
    name: "Payments",
    path: "payments",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.PAYMENTS],
    scope: "RangoliSellerDesktopPaymentsModule",
    module: "./Payments",
  },
  [MicroFrontends.DELIVERY_SETTINGS]: {
    key: MicroFrontends.DELIVERY_SETTINGS,
    name: "Delivery",
    path: "delivery-settings",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.DELIVERY_SETTINGS],
    scope: "RangoliSellerDesktopDeliveryModule",
    module: "./DeliverySettings",
  },
  [MicroFrontends.WEBSITE_APPEARANCE]: {
    key: MicroFrontends.WEBSITE_APPEARANCE,
    name: "Website Appearance",
    path: "store-appearance",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.WEBSITE_APPEARANCE],
    scope: "RangoliSellerTemplateEditor",
    module: "./StoreAppearance",
  },
  [MicroFrontends.STORE_TIMINGS]: {
    key: MicroFrontends.STORE_TIMINGS,
    name: "Store Timings",
    path: "store-timings",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.STORE_TIMINGS],
    scope: "RangoliSellerDesktopStoreTimingsModule",
    module: "./StoreTiming",
  },
  [MicroFrontends.PROFILE]: {
    key: MicroFrontends.PROFILE,
    name: "Profile",
    path: "profile",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.PROFILE],
    scope: "RangoliSellerDesktopProfileModule",
    module: "./Profile",
  },
  [MicroFrontends.PERFORMANCE_MARKETING]: {
    key: MicroFrontends.PERFORMANCE_MARKETING,
    name: "Performance Marketing",
    path: "performance-marketing",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.PERFORMANCE_MARKETING],
    scope: "RangoliSellerDesktopPerformanceMarketingModule",
    module: "./PerformanceMarketing",
  },
  [MicroFrontends.OFFERS]: {
    key: MicroFrontends.OFFERS,
    name: "Offers & Discounts",
    path: "offers",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.OFFERS],
    scope: "RangoliSellerDesktopOffersModule",
    module: "./Offers",
  },
  [MicroFrontends.CUSTOM_DOMAIN]: {
    key: MicroFrontends.CUSTOM_DOMAIN,
    name: "Custom Domain",
    path: "custom-domain",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.CUSTOM_DOMAIN],
    scope: "RangoliSellerDesktopCustomDomainModule",
    module: "./CustomDomain",
  },
  [MicroFrontends.GOOGLE_ANALYTICS]: {
    key: MicroFrontends.GOOGLE_ANALYTICS,
    name: "Google Analytics",
    path: "performance-marketing/google-analytics",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.GOOGLE_ANALYTICS],
    scope: "RangoliSellerDesktopPerformanceMarketingModule",
    module: "./GoogleAnalytics",
  },
  [MicroFrontends.USER_MANAGEMENT]: {
    key: MicroFrontends.USER_MANAGEMENT,
    name: "User Management",
    path: "user-management",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.USER_MANAGEMENT],
    scope: "RangoliSellerDesktopUserManagementModule",
    module: "./UAM",
  },
  [MicroFrontends.SEO]: {
    key: MicroFrontends.SEO,
    name: "SEO",
    path: "performance-marketing/seo",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.SEO],
    scope: "RangoliSellerDesktopPerformanceMarketingModule",
    module: "./SEO",
  },
  [MicroFrontends.RETURN_SETTINGS]: {
    key: MicroFrontends.RETURN_SETTINGS,
    name: "Returns",
    path: "orders/returns/config",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.RETURN_SETTINGS],
    scope: "RangoliSellerDesktopOMSModule",
    module: "./ReturnSettings",
  },
  [MicroFrontends.SETTINGS]: {
    key: MicroFrontends.SETTINGS,
    name: "Settings",
    path: "settings",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.SETTINGS],
    scope: "RangoliSellerDesktopProfileModule",
    module: "./Profile",
  },
  [MicroFrontends.MARKETING_AUTOMATION]: {
    key: MicroFrontends.MARKETING_AUTOMATION,
    name: "Marketing Automation",
    path: "performance-marketing/marketing-automation",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.MARKETING_AUTOMATION],
    scope: "RangoliSellerDesktopPerformanceMarketingModule",
    module: "./MarketingAutomation",
  },
  [MicroFrontends.REVIEWS]: {
    key: MicroFrontends.REVIEWS,
    name: "Reviews",
    path: "reviews",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.REVIEWS],
    scope: "RangoliSellerDesktopReviewsRatingsModule",
    module: "./Reviews",
    subModules: {
      [MicroFrontendSubModules[MicroFrontends.REVIEWS].MANAGE]: {
        name: "Manage",
        path: "manage",
      },
    }
  },
  [MicroFrontends.REVIEW_SETTINGS]: {
    key: MicroFrontends.REVIEW_SETTINGS,
    name: "Review Settings",
    path: "reviews",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.REVIEW_SETTINGS],
    scope: "RangoliSellerDesktopReviewsRatingsModule",
    module: "./Settings",
  },
  [MicroFrontends.CONNECTIONS]: {
    key: MicroFrontends.CONNECTIONS,
    name: "Connections",
    path: "connections",
    remoteUrl: MicroFrontendEndpoints[MicroFrontends.CONNECTIONS],
    scope: "RangoliSellerDesktopMarketplaceConnector",
    module: "./MarketplaceConnector",
  },
};
